import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../notifications/actions/notification';
import { actions } from '../actions/conversation';
import * as conversationsActions from '../actions/conversations';
import Conversation from '../components/Conversation';
import { getLatestFacebookConversation } from '../selectors';

const { conversationsResetUnread } = conversationsActions.actions;
const { notificationTabBadgeReset } = notificationActions;

const mapStateToProps = (state) => {
  return {
    metaConversation: state.conversation.metaConversation,
    latestMessengerConversation: getLatestFacebookConversation(state),
    isFocusMode: state.conversation.isFocusMode,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    conversationGet: bindActionToPromise(dispatch, actions.conversationGet),
    notificationTabBadgeReset: () => dispatch(notificationTabBadgeReset()),
    conversationResetUnread: (payload: { csid: string }) =>
      dispatch(conversationsResetUnread(payload)),
    conversationUnmount: () => dispatch(actions.conversationUnmount()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversation);
